<template>
    <Modal v-model="visible" :z-index="1500" :width="60" :mask-closable="false">
        <template #header>
            <div style="display: flex;justify-content: space-between;align-items: baseline;margin-top:30px">
                <div style="font-size: 16px">
                    <span :style="{color: currentPath.path == '' ? '#000': '#aaa',cursor: 'pointer'}" @click="handleGetDir({path: '',name: ''},-1)">百度网盘剧集</span> 
                    <Icon type="ios-arrow-forward" style="color: #aaa" v-if="pathLi.length" />
                    <span v-for="(item,index) in pathLi" :key="index" @click="handleGetDir(item,index)" :style="{color: currentPath.name == item.name ? '#000': '#aaa',cursor: 'pointer'}">
                        {{ item.name }} 
                        <Icon type="ios-arrow-forward" v-if="index!=pathLi.length-1" />
                    </span>
                </div>
                <div style="">
                    <a style="margin-right: 20px;font-size: 15px;" @click="handleGetDir(currentPath, pathLi.findIndex(i=>i.name == currentPath.name))" > 重新获取</a>
                    <span v-if="dirLi.filter(i=>i.type=='1').length && !single" style="font-size: 15px;cursor:pointer" @click="()=>{
                        
                    }" > 
                        <Checkbox :value="!dirLi.filter(i=>i.type=='1'&&!selectedMp4.includes(i.baiduFileId)).length"
                        @on-change="(e)=>{
                            const li = dirLi.filter(i=>i.type=='1').map(i=>i.baiduFileId)
                            if(e){
                                li.map(i=>{
                                    if(!selectedMp4.includes(i)){
                                        selectedMp4.push(i)
                                    }
                                })
                            }else{
                                li.map((i)=>{
                                    const index = selectedMp4.indexOf(i)
                                    if(index>-1){
                                        selectedMp4.splice(index,1)
                                    }
                                })
                            }
                        }"
                        >全选视频文件</Checkbox>
                    </span>

                </div>
            </div>
        </template>
        <div style="max-height: 500px;overflow:auto">
            <div v-if="!loading&&finish&&dirLi.length">
                <CheckboxGroup v-model="selectedMp4">
                    <div v-for="(item,index) in dirLi" :key="index" style="padding: 5px 10px">
                        <div :class="{
                            selected: selectedFolder.path == item.path||selectedMp4.includes(item.baiduFileId)
                        }" style="padding: 10px 20px;border-radius: 10px;cursor:pointer;color:#4d5a69;display:flex;align-items: center;justify-content: space-between;border: 1px solid transparent;border-bottom: 1px solid #eee;" 
                        @dblclick="handleGetDir(item)" @click="handleSelect(item)">
                            <div style="display: flex;align-items: center;">
                                <div style="width: 30px">
                                    <Checkbox v-if="item.type==1" :label="item.baiduFileId">
                                    {{  }}
                                    </Checkbox>
                                </div>
                                <Icon type="ios-folder" v-if="item.type==0" :size="16" style="margin-right: 20px;color:#75a8d7" />
                                <Icon type="ios-film" v-else :size="16" style="margin-right: 20px;" />
                            {{ item.name }}
                            </div>
                            <Icon type="ios-arrow-forward" v-if="item.type=='0'" :size="18" />
                        </div>
                    </div>
                </CheckboxGroup>
            </div>
            <div v-else-if="loading" style="padding: 50px 0;text-align: center;">
                <Spin>加载中...</Spin>
            </div>
            <div v-else-if="!finish" style="padding: 50px 0;text-align: center;">
                加载失败
            </div>
            <div v-else style="padding: 50px 0;text-align: center;">
                暂无文件
            </div>
        </div> 
        <template #footer>
            <Button @click="visible = false;dirLi = [];pathLi=[];selectedFolder={};selectedMp4=[];currentPath={}">取消</Button>
            <Button v-if="selectedMp4.length" @click="handleChooseSeries" type="primary" :loading="submitLoading">选择</Button>
            <Button v-else @click="handleGetDir(selectedFolder)" type="primary">打开</Button>
        </template>
    </Modal>
</template>

<script>
import { getBaiduPath } from '@/api/play'
export default {
    props: {
        appId: "",
        chooseSeries:{
            type: Function,
            default: ()=> Promise.resolve(true)
        }
    },
    data(){
        return {
            visible: false,
            currentPath: {},
            loading: false,
            single: false,
            submitLoading: false,
            pathLi: [],
            finish: false,
            selectedFolder: {},
            selectedMp4: [],
            dirLi: []
        }
    },
    watch:{
        visible(){
            if(this.visible){
                this.handleGetDir({
                    path: '',
                    name: ''
                },-1)
            }
        }
    },
    methods:{
        handleSelect(item){
            if(item.type == '1'){
                if(this.single) this.selectedMp4 = [item.baiduFileId]
                else {
                    const index = this.selectedMp4.indexOf(item.baiduFileId)
                    if(index<0)
                    this.selectedMp4.push(item.baiduFileId)
                    else this.selectedMp4.splice(index,1)
                }
                // const row = this.selectedMp4.findIndex(i=>i == item.baiduFileId)
                // if(row<0){
                //     this.selectedMp4.push(item.path)
                // }else{
                //     this.selectedMp4.splice(row,1)
                // }
            }
            // const row = this.selectedFolder.findIndex(i=>i == item.path)
            this.selectedFolder = {...item}
            // if(row<0){
            //     this.selectedFolder.push(item.path)
            // }else{
            //     this.selectedFolder.splice(row,1)
            // }
        },
        async handleChooseSeries(){
            // this.visible = false
            this.submitLoading = true
            // console.log(this.chooseSeries(this.selectedMp4,this.currentPath));
            if(this.single){
                this.$emit('get-choosed',this.selectedMp4[0])
                this.submitLoading = false
                return 
            }
            try{
                await this.chooseSeries(this.selectedMp4,this.currentPath)
                this.selectedMp4 = []
                this.dirLi = []
                this.pathLi = []
                this.selectedFolder = {}
                this.currentPath = {}
            }finally{
                this.submitLoading = false
            }
            // this.$emit('choose-series',this.selectedMp4,this.currentPath)
            
        },
        handleGetDir(e,index){
            if(e.type&&e.type=='1')return
            this.selectedMp4 = []
            if(index == -1){
                this.pathLi = []
            }
            else if(index||index == 0){
                this.pathLi = this.pathLi.slice(0,index+1)
            }else {
                if(e)
                this.pathLi.push(e)
            }
            this.dirLi = []
            this.currentPath = e
            this.loading = true
            getBaiduPath({
                appId: this.appId,
                path: e.path
            }).then(r=>{
                this.dirLi = r.data
                this.finish = true
            }).catch(e=>{
                this.dirLi = []
                this.finish = false
            }).finally(()=>{
                this.loading = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ivu-modal-wrap{
    z-index: 1001 !important;
}
/deep/.ivu-modal-mask{
    z-index: 1001 !important;

}
.selected{
    background-color: #f2f7fc;border:1px solid #e9f1fb;
}
</style>